// import React from 'react';
// import { FaWhatsapp, FaPhone } from 'react-icons/fa';

// const ContactActions = () => {
//   return (
//     <div className="container mx-30 item-center
//      mx-auto  px-4 py-12">
//       <div className="grid ml-30 h-[200px] item-center  w-[900px] grid-cols-1 md:grid-cols-2 gap-6">
//         {/* WhatsApp Us */}
//         <a
//           href="https://wa.me/2349055556666"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="bg-green-500 text-white p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-green-600 transition-all duration-300 flex items-center justify-center gap-4 transform hover:-translate-y-2"
//         >
//           <FaWhatsapp className="text-3xl" />
//           <div className="text-center">
//             <h3 className="text-lg font-semibold">WhatsApp Us</h3>
//             <p className="text-sm text-gray-200">Chat with us now!</p>
//           </div>
//         </a>

//         {/* Call Us */}
//         <a
//           href="tel:+2349055556666"
//           className="bg-blue-500 text-white p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-blue-600 transition-all duration-300 flex items-center justify-center gap-4 transform hover:-translate-y-2"
//         >
//           <FaPhone className="text-3xl" />
//           <div className="text-center">
//             <h3 className="text-lg font-semibold">Call Us</h3>
//             <p className="text-sm text-gray-200">+234 905 555 6666</p>
//           </div>
//         </a>
//       </div>
//     </div>
//   );
// };

// export default ContactActions;


import React from 'react';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';

const ContactActions = () => {
  return (
    <div className="container mx-auto px-4 py-12  flex items-center justify-center">
      <div className="grid h-[200px] item-center  w-[900px] grid-cols-1 md:grid-cols-2 gap-6">
        {/* WhatsApp Us */}
        <a
          href="https://wa.me/2349055556666"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 text-white p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-green-600 transition-all duration-300 flex items-center justify-center gap-4 transform hover:-translate-y-2"
        >
          <FaWhatsapp className="text-3xl" />
          <div className="text-center">
            <h3 className="text-lg font-semibold">WhatsApp Us</h3>
            <p className="text-sm text-gray-200">Chat with us now!</p>
          </div>
        </a>

        {/* Call Us */}
        <a
          href="tel:+2349055556666"
          className="bg-blue-500 text-white p-6 rounded-lg shadow-md hover:shadow-lg hover:bg-blue-600 transition-all duration-300 flex items-center justify-center gap-4 transform hover:-translate-y-2"
        >
          <FaPhone className="text-3xl" />
          <div className="text-center">
            <h3 className="text-lg font-semibold">Call Us</h3>
            <p className="text-sm text-gray-200">+234 905 555 6666</p>
          </div>
        </a>
      </div>
    </div>
  );
};

export default ContactActions;